import React from 'react';
import { ComponentMaskProvider } from '../../ComponentMaskContext';
import { useRequiredCurrentUserGroups } from '../../hooks/useRequiredCurrentUserGroups';
import { AuthBoundaryType } from './AuthBoundaryType';
import { DefaultUnauthorizedSplash } from './DefaultUnauthorizedSplash';
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export const AuthBoundary = _ref => {
  let {
    children,
    requiredGroups,
    unauthorizedComponent = /*#__PURE__*/_jsx(DefaultUnauthorizedSplash, {}),
    boundaryType = AuthBoundaryType.Mask
  } = _ref;
  const {
    isAuthorizedForRequiredGroups,
    isAuthorizedForBuzz,
    isLoading
  } = useRequiredCurrentUserGroups(requiredGroups);
  if (isLoading) {
    return /*#__PURE__*/_jsx(_Fragment, {});
  }
  const Unauthorized = () => {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: unauthorizedComponent
    });
  };
  if (!isAuthorizedForBuzz) {
    return /*#__PURE__*/_jsx(Unauthorized, {});
  }
  if (!isAuthorizedForRequiredGroups && boundaryType === AuthBoundaryType.Block) {
    return /*#__PURE__*/_jsx(Unauthorized, {});
  }
  if (!isAuthorizedForRequiredGroups && boundaryType === AuthBoundaryType.Mask) {
    return /*#__PURE__*/_jsx(ComponentMaskProvider, {
      isMasked: true,
      children: children
    });
  }
  return /*#__PURE__*/_jsx(ComponentMaskProvider, {
    children: children
  });
};